import { useEffect } from "react";

// Re-run `fn` whenever the page becomes active again: tab focus, visibility
// change, or bfcache restore (Android PWA freeze/return). Keeps lists fresh so a
// newly created job/report shows the moment you come back — no app restart needed.
// `fn` must be stable (wrap in useCallback).
export function useRefetchOnActive(fn) {
  useEffect(() => {
    const onFocus = () => { if (!document.hidden) fn(); };
    const onVisible = () => { if (!document.hidden) fn(); };
    const onPageShow = (e) => { if (e.persisted) fn(); };
    // Back/forward (hardware or in-app) can restore a FROZEN page from bfcache
    // without remounting React — refetch on popstate so progress wheels/lists are
    // never stale after navigating back from an editor.
    const onPop = () => { if (!document.hidden) fn(); };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("pageshow", onPageShow);
    window.addEventListener("popstate", onPop);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("pageshow", onPageShow);
      window.removeEventListener("popstate", onPop);
    };
  }, [fn]);
}
